module.exports = __webpack_public_path__ + "static/media/icon_my-bag_on.a2b74484.svg";